module.exports = __webpack_public_path__ + "static/media/Whisky glass woman-4252 (credit OurWhisky Foundation_Jo Hanley).82d39877.jpg";